export default {
    "apiUrl": 'https://api-mmzwe.cactusminds.com/backend/',
    "audioUrl": 'https://api-mmzwe.cactusminds.com',
    // "apiUrl": 'https://api.mmzwe.com/backend/',
    // "audioUrl": 'https://api.mmzwe.com',
    // "apiUrl": 'http://localhost:8000/backend/',
    // "audioUrl": 'http://localhost:8000',
}